<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">

      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader3"
            :border="true"
            :loading="isLoading"
            :data="tableData3"
            stripe
            ref="table"
          >
            <template slot-scope="{ row, index }" slot="action3">
              <!-- <span class="action">[删除]</span> -->
              <span class="action"  @click="handleschoolDetail1(row)">[修改]</span>
            </template>

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total3"
            :current="pageNum3"
            @on-change="pageChange3"
            show-total
          />
        </div>
      </div>

      <Modal  v-model="modal4" title="设置教育局信息">
          <i-form ref="search" :model="query4">
            <row :gutter="80">
              <i-col span="12">
                <form-item label="行政区域" prop="schoolRegion">
                  <Select v-model="query4.schoolRegion" clearable>
                    <Option
                      v-for="item in schoolRegionlist"
                      :key="item.index"
                      :value="item.type"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="关联部门" prop="deptId">
                  <Select v-model="query4.deptId" clearable>
                    <Option
                      v-for="item in deptNamelist1"
                      :key="item.index"
                      :value="item.id"
                      :label="item.dept_name"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="教育局名称" prop="schoolName">
                  <Input
                    v-model="query4.schoolName"
                    clearable
                    placeholder="请输入"
                  />
                </form-item>
              </i-col>
                <i-col span="12">
                  <form-item label="教育局地丘号" prop="schoolLandNum">
                    <Input
                      v-model="query4.schoolLandNum"
                      clearable
                      placeholder="请输入,格式如:1,2,3"
                    />
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item label="教育局地址" prop="schoolAddress">
                    <Input
                      v-model="query4.schoolAddress"
                      clearable
                      placeholder="请输入教育局地址"
                    />
                  </form-item>
                </i-col>
                <i-col span="12">
                  <form-item label="教育局介绍" prop="schoolInfo">
                    <Input type="textarea"
                      v-model="query4.schoolInfo"
                      clearable
                      placeholder="请输入教育局介绍"
                    />
                  </form-item>
                </i-col>
             </row>
          </i-form>
          <div slot="footer">
              <Button type="error" size="large" long  @click="surerevise1">确认</Button>
          </div>
      </Modal>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const {
  selectAllCommitStudent,//学生列表信息
  selectSignUpCommitInfo,
  selectSchoolInfo,
  insertNewStudentSchool,
  getadminVerifyList,
  deleteAllInfoByStudentId,//伪删除
  educationPermissionCheck,//查询是否教育局
  assignSchool,
  selectDeptList,
  selectAllEducationInfo,
  exportExcelByMap
} = api;

export default {
  name: "landTransfer",
  components: {
    pageHead,
  },

  data() {
    return {
      btnList: [
        {name: "新增",type: "add"},
      ],
      iseducation:false,
      modal4:false,
      tapidnex:4,
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      showPreview: {
        show: 0,
        list: [],
      },
      schoolRegionlist:[
        {index: 0,type: "市直"},
        {index: 1,type: "油田"},
        {index: 2,type: "开发区"},
        {index: 3,type: "华龙区"},
        {index: 4,type: "示范区"},
      ],
      deptNamelist1:[],
      query4: {
        "id":'',
       	"schoolName": "",
       	"schoolType": "教育局",
       	"schoolAddress": "",
       	"schoolLandNum": "",
       	"schoolInfo": "",
        "deptId":'',
        'schoolRegion':''
      },
      shoolquery:{
        schoolId:''
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum3: 1,
      pageSize3: 10,
      total3: 0,
      title: "新生入学",
      tableHeader3: [
        {title: "教育局序号",key: "id",width:90,},
        {title: "教育局名称",key: "schoolName",width:160},
        {title: "行政区域",key: "schoolRegion",width:100},
        {title: "教育局地丘号",key: "schoolLandNum",minWidth:520},
        {title: "关联部门",key: "deptName",width:160},
        {title: "教育局地址",key: "schoolAddress",width:160},
        {title: "描述",key: "schoolInfo",width:160},
        {title: "操作",slot: "action3",width:90},
      ],
      tableData3: [],
      selectedList: [],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    handleBtn(type){
      if (type == "add") {
       this.query4={
        "id":'',
        "schoolName": "",
        "schoolType": "教育局",
        "schoolAddress": "",
        "schoolLandNum": "",
        "schoolInfo": "",
        "deptId":'',
        'schoolRegion':''
       }
       this.modal4=true;
      }
    },
    handleschoolDetail1(row){
      console.log(row)
      let deptId=''
      if(row.deptName){
        for(let i=0;i<this.deptNamelist1.length;i++){
          if(this.deptNamelist1[i].dept_name==row.deptName){
            deptId=this.deptNamelist1[i].id
            break;
          }
        }
      }
      this.query4={
        "id":row.id,
        "schoolName":row.schoolName,
        "schoolType":"教育局",
        "schoolAddress":row.schoolAddress,
        "schoolLandNum":row.schoolLandNum,
        "schoolInfo": row.schoolInfo,
        "deptId":deptId,
        'schoolRegion':row.schoolRegion
      }
      this.modal4=true;
    },
    async surerevise1 () {
        if(this.query4.schoolRegion!==0){
          if(!this.query4.schoolRegion){
            this.$Message.success("请选择教育局行政区域");
            return ;
          }
        }
        if(!this.query4.deptId){
          this.$Message.success("请选择教育局关联部门");
          return ;
        }
       if(!this.query4.schoolName){
         this.$Message.success("请输入教育局名称");
         return ;
       }
       if(!this.query4.schoolLandNum){
         this.$Message.success("请输入教育局地丘号");
         return ;
       }
       // if(!this.query4.schoolAddress){
       //   this.$Message.success("请输入教育局地址");
       //   return ;
       // }
       // if(!this.query4.schoolInfo){
       //   this.$Message.success("请输入教育局描述");
       //   return ;
       // }
       if(this.query4.schoolType){
         this.query4.schoolType=this.query4.schoolType.replace(/，/g,",")
       }
       if(this.query4.schoolLandNum){
         this.query4.schoolLandNum=this.query4.schoolLandNum.replace(/，/g,",")
       }
       console.log(this.query4)
       let res = await this.$post(insertNewStudentSchool, {
         ...this.query4,
       });
       if (res.isSucceed) {
         this.$Message.success("保存成功");
         this.getLandTransferList3();
         this.modal4=false;
       }
    },
    cancelModal() {},

    pageChange3(val) {
      this.pageNum3 = val;
      this.getLandTransferList3();
    },


    async geteducationPermissionCheck(){
      if(localStorage["uid"]){
        let url=educationPermissionCheck+localStorage["uid"]
        let res = await this.$post(url, {});
        console.log(res)
        if (res.isSucceed&&res.code==1) {
          this.iseducation=true
        }else{
          this.iseducation=false
        }
      }else{
        this.$Message.info("uid过期，请重新登录");
      }
    },

    async getLandTransferList3() {
      this.isLoading = true;
      let url=selectAllEducationInfo+"/"+this.pageNum3+"/"+this.pageSize3
      try {
        let res = await this.$get(url);
        if(res.rows&&res.rows.length>0){
          let list = res.rows[0].list.map((item) => ({
            ...item
          }));
          console.log(list);
          this.tableData3 = list;
          this.total3 = res.rows[0].total;
        }

      } finally {
        this.isLoading = false;
      }
    },
    async getselectDeptList(type) {
      this.isLoading = true;
      let url=selectDeptList+type
      let res = await this.$post(url);
      if(res.rows&&res.rows.length>0){
        for(let i=0;i<res.rows.length;i++){
          res.rows[i].index=i
        }
        console.log(res.rows)
        if(type==1){//学校关联部门
          this.deptNamelist = res.rows;
        }else if(type==2){//教育局关联部门
          this.deptNamelist1 = res.rows;
        }

      }
    },


  },

  created() {
    this.modal4=false;
    this.getLandTransferList3()
    this.getselectDeptList(2)
    this.geteducationPermissionCheck()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding-top: 20px;
  min-height: calc(100vh - 170px);
  .page {width: 100%;margin-top: 10px;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
